import { Box, IconButton } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IconClose } from "src/components/icons-mui/close";
import { AnimatedHeading } from "src/components/pages/search/components/animated-heading";

interface ISearchFilterHeaderProps {
    handleOnClear: () => void;
    isMobile?: boolean;
    searchTerm?: string | string[];
}

const mobileIconStyles = {
    marginTop: "-4px",
    marginRight: "-8px",
};

export const SearchFilterHeader = ({ searchTerm, isMobile, handleOnClear }: ISearchFilterHeaderProps) => {
    const { t } = useTranslation(["extended-search", "common"]);
    const iconButtonStyles = isMobile ? mobileIconStyles : undefined;
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: isMobile ? "space-between" : "initial",
                alignItems: isMobile ? "initial" : "baseline",
            }}
        >
            <AnimatedHeading searchTerm={searchTerm} headline={t("headlines.find-wikifolios")} isMobile={isMobile} />
            {searchTerm && (
                <IconButton
                    aria-label={t("clear", { ns: "common" })}
                    onClick={handleOnClear}
                    variant="ghost"
                    sx={{ borderRadius: "50%", width: 40, height: 40, minWidth: 40, ml: 1, ...iconButtonStyles }}
                >
                    <IconClose sx={{ fontSize: 24 }} />
                </IconButton>
            )}
        </Box>
    );
};
